//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CRUDGenerico from '../../../../shared-components/generico/CRUDGenerico';
import SideColumn from './SideColumn';
import CentroCustoTabela from './CentroCustoTabela';

import { copyObject } from '../../../../common/functions/helpers';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'CentroCusto',
  extends: CRUDGenerico,
  data() {
    return {
      centroCustoResources: this.$api.centroCusto(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      tableHeader: [
        {
          name: this.$t('label.codigo'),
          tooltip: this.$t('label.cod_centro_custo'),
          sortType: 'idExterno',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.nome'),
          tooltip: this.$t('label.nome'),
          sortType: 'nome',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$tc('label.unidade_negocio', 1),
          tooltip: this.$tc('label.unidade_negocio', 1),
          sortType: 'unidadeNegocio',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.canal'),
          tooltip: this.$t('label.canal'),
          sortType: 'canais',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.marca'),
          tooltip: this.$t('label.marca'),
          sortType: 'marcas',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$tc('label.cliente', 1),
          tooltip: this.$tc('label.cliente', 1),
          sortType: 'composicao',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$tc('label.produto', 1),
          tooltip: this.$tc('label.produto', 1),
          sortType: 'composicao',
          classes: ['md-hide-medium'],
        },
      ],
      tableRows: [],
      carregando: false,
      paginas: 0,
      limitePagina: 20,
      searchQuery: '',
      statusFilter: 'true',
    };
  },
  computed: {
    ...generateComputed('Ceco', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
  },
  components: {
    SideColumn,
    CentroCustoTabela,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    alterarTamanhoPagina(valor) {
      this.limitePagina = valor;
      this.requestPopular();
    },
    filtrarPorStatus(status) {
      this.statusFilter = status;
      this.requestPopular();
    },
    filtrar(searchQuery) {
      this.searchQuery = searchQuery;
      this.requestPopular();
    },
    requestAdicionar(objeto, cb = null) {
      const payload = copyObject(objeto);

      delete payload.dependencias.canais;
      delete payload.dependencias.marcas;
      delete payload.dependencias.unidadeNegocio;

      this.centroCustoResources.gravar(payload)
        .then((docs) => {
          objeto.id = docs.data.id;

          this.tableRows.unshift(objeto);
          this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestAtivarInativar(index) {
      const row = this.tableRows[index],
        id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.centroCustoResources);
    },
    requestAtualizar(objeto) {
      const payload = Object.assign({}, objeto);
      const idsCanal = payload.dependencias.canais.map(el => el.id);
      const idsMarca = payload.dependencias.marcas.map(el => el.id);
      const idUnidadeNegocio = payload.dependencias.unidadeNegocio.id;

      delete payload.dependencias;
      delete payload.canais;
      delete payload.marcas;
      delete payload.unidadenegocio;
      delete payload.codUnidadenegocio;

      payload.dependencias = {};
      payload.dependencias.idsCanal = idsCanal;
      payload.dependencias.idsMarca = idsMarca;
      payload.dependencias.idUnidadeNegocio = idUnidadeNegocio;

      this.centroCustoResources.atualizar(payload)
        .then(() => {
          this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          this.requestPopular();
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestExportacao(cb) {
      this.exportar(cb, 'centro_custo');
    },
    requestPopular(page = 1, cb = null) {
      // this.requestPopularGenerico(this.centroCustoResources.listar, page, cb);
      this.$refs.centroCustoTabela.clearCheckbox();
      this.carregando = true;
      const filtro = {};
      filtro.page = page;
      filtro.size = this.limitePagina;
      filtro.nome = this.searchQuery;
      if (this.statusFilter !== '') {
        filtro.indAtivo = this.statusFilter;
      }
      this.centroCustoResources.listar(filtro).then((response) => {
        this.tableRows = response.data.resposta;
        const qtdeRegistros = response.data.quantidadeRegistrosPagina;
        this.paginas = Math.ceil(qtdeRegistros / filtro.size);
        this.carregando = false;
        if (cb) {
          cb();
        }
      })
      .catch((err) => {
        this.carregando = false;
        this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    } else {
      this.requestPopular();
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/centro-custo/CentroCusto.vue?vue&type=script&lang=js&